import React from "react"
// nodejs library to set properties for components
import PropTypes from "prop-types"
// nodejs library that concatenates classes
import classNames from "classnames"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

import infoStyle from "../../assets/jss/material-kit-react/components/infoStyle.jsx"

function InfoArea({ ...props }) {
    const { classes, title, description, iconColor, vertical, iconDescription } = props
    const iconWrapper = classNames({
        [classes.iconWrapper]: true,
        [classes[iconColor]]: true,
        [classes.iconWrapperVertical]: vertical,
    })
    const iconClasses = classNames({
        [classes.icon]: true,
        [classes.iconVertical]: vertical,
    })

    if (!props.icon) {
        return (
            <div className={classes.infoArea}>
                <div className={classes.descriptionWrapper}>
                    <h4 className={classes.title} style={{ marginTop: "1rem" }}>
                        {title}
                    </h4>
                    <p className={classes.description}>{description}</p>
                </div>
            </div>
        )
    }
    return (
        <div className={classes.infoArea}>
            <div
                className={iconWrapper}
                style={{
                    color: "rgb(34, 36, 37)",
                    textAlign: "center",
                    margin: 0,
                    marginTop: "2rem",
                }}>
                {props.pngIcon ? (
                    <img src={props.pngIcon} alt="..." style={{ height: "10rem", width: "12rem" }} />
                ) : (
                    <props.icon className={iconClasses} />
                )}
            </div>
            <div className={classes.infoArea} style={{ textAlign: "center", paddingTop: "1.2rem" }}>
                <span
                    style={{
                        fontSize: "1rem",
                        color: "rgb(60, 72, 88)",
                        fontWeight: "700",
                    }}>
                    {iconDescription}
                </span>
            </div>
            <div className={classes.descriptionWrapper}>
                <h4 className={classes.title}>{title}</h4>
                <p className={classes.description}>{description}</p>
            </div>
        </div>
    )
}

InfoArea.defaultProps = {
    iconColor: "gray",
}

InfoArea.propTypes = {
    classes: PropTypes.object.isRequired,
    icon: PropTypes.func,
    pngIcon: PropTypes.any,
    title: PropTypes.string.isRequired,
    iconDescription: PropTypes.string,
    description: PropTypes.string.isRequired,
    iconColor: PropTypes.oneOf(["primary", "warning", "danger", "success", "info", "rose", "gray"]),
    vertical: PropTypes.bool,
}

export default withStyles(infoStyle)(InfoArea)



// WEBPACK FOOTER //
// ./src/components/InfoArea/InfoArea.jsx